export const REQUEST_TYPES = [
  { value: 'Request Access', label: 'Request Access' },
  { value: 'Report an issue', label: 'Report an issue' },
  { value: 'Other Request', label: 'Other Request' },
];
